import { FC, InputHTMLAttributes, useRef } from "react";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | string[] | JSX.Element;
  borderError?: string;
  wrapperStyles?: any;
}

const AmountInput: FC<Props> = ({
  label = "",
  error,
  wrapperStyles = {},
  borderError,
  ...props
}) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div className={clsx(styles.input, wrapperStyles)}>
      <div className={styles.inputWrapper}>
        <input
          onWheel={(e) => {
            //@ts-ignore
            e.target?.blur();
            e.stopPropagation();
          }}
          className={clsx(styles.input__main, {
            [styles.error]: error || borderError,
          })}
          type="number"
          {...props}
        />
      </div>

      {Array.isArray(error) && error?.length > 1 ? (
        error.map((error, index) => <p key={index}>{error}</p>)
      ) : error ? (
        <p>{error}</p>
      ) : null}
    </div>
  );
};

export default AmountInput;
